import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { HttpClient } from '@angular/common/http';
import { AuthService, ResponseObject } from './auth.service';
import { environment } from 'src/environments/environment';
import { Admins } from '../models/admin.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminService extends ServiceBase{
  private api: string = '/AdminManagment';

  constructor(private http: HttpClient,
    authService: AuthService) { 
      super(authService);
  }

  public getAllAdmins(): Observable<Admins[]>{
    var HttpOptions = this.RequestHeaders();
    var method: string = `/fetch`;
    var url: string = environment.BASE_API_PATH + this.api + method
    return this.http.get<Admins[]>(url,HttpOptions)
  }

  public saveAdmin(createTopic: Admins): Observable<ResponseObject>{
    var HttpOptions = this.RequestHeaders();
    var method: string = `/saveAdmin`;
    var url: string = environment.BASE_API_PATH + this.api + method
    return this.http.post<ResponseObject>(url,createTopic,HttpOptions)
  }

  public deleteAdmin(id?: string): Observable<ResponseObject>{
    var HttpOptions = this.RequestHeaders();
    var method: string = `/delete/${id}`;
    var url: string = environment.BASE_API_PATH + this.api + method
    return this.http.delete<ResponseObject>(url,HttpOptions)
  }

}
